import React, { memo } from "react"
import ReactSelect from "react-select"
import { isBrowser } from "react-device-detect"

import theme from "theme"
import { QuestionResponseValue, QuestionResponseField } from "typings/quiz"
import { Options, Option } from "typings/select-options"
import { customReactSelectStyles, HTMLSelectContainer, HTMLSelect } from "./styles"

type SelectWrapperProps = {
  onChange: (value: any) => void
  placeholder?: string
  value?: string | QuestionResponseValue
  options: Options<string>
  disabled?: boolean
  handleResetError?: () => void
  error?: boolean
  label?: React.ReactNode
  name?: QuestionResponseField | string
  isMultiChoice?: boolean
  isSearchable?: boolean
  selectedOptions: Option<NonNullable<QuestionResponseValue>>[] | Option<string> | undefined
  forceNonNativeMobileInput?: boolean
  dataTest?: string
}

const Select: React.FC<SelectWrapperProps> = ({
  name,
  value: inputValue,
  options,
  disabled,
  onChange,
  placeholder,
  selectedOptions,
  isMultiChoice = false,
  isSearchable = false,
  forceNonNativeMobileInput = false,
  error = false,
  dataTest
}) => {
  // Important to keep value as the empty string by default so that on mobile
  // devices the placeholder option is selected by default
  let value: undefined | string | string[] = ""

  if (isMultiChoice && !inputValue) {
    value = []
  } else if (isMultiChoice && !!inputValue) {
    value = inputValue
      .toString()
      .split(",")
      .filter((item: string) => item)
  } else if (inputValue) {
    value = inputValue.toString()
  }

  if (isBrowser || forceNonNativeMobileInput) {
    return (
      <ReactSelect
        value={selectedOptions as any}
        options={options}
        onChange={onChange}
        styles={customReactSelectStyles({
          error,
          optionFontStyles: { fontFamily: theme.fonts.paragraph, textTransform: "capitalize" }
        })}
        placeholder={placeholder}
        isDisabled={disabled}
        isMulti={isMultiChoice}
        isSearchable={isSearchable}
        classNamePrefix={`${dataTest}Desktop`}
      />
    )
  }

  return (
    <HTMLSelectContainer error={error}>
      <HTMLSelect
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        multiple={isMultiChoice}
        data-test={`${dataTest}Mobile`}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option: any) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </HTMLSelect>
    </HTMLSelectContainer>
  )
}

export default memo(Select)
